/** The anchor every block of the Tour tab has: band nodes and `tour#<block>` links land
 *  on it. (A block heading row's height is the records' `HEADING_ROW_PX`.) */
import { Box } from '@mui/material';
import type { ReactNode } from 'react';

import { blockAnchorId, type TourBlockId } from '../registry';

/** A block anchor: band nodes and `tour#<block>` land here. */
export function BlockAnchor({ id, label, children }: { id: TourBlockId; label: string; children: ReactNode }) {
  return (
    <Box
      id={blockAnchorId(id)}
      component="section"
      tabIndex={-1}
      aria-label={label}
      data-tour-block={id}
      sx={{
        scrollMarginTop: 'var(--record-spine-height, 0px)',
        outline: 'none',
        borderRadius: 1,
        '&:focus-visible': { boxShadow: (t) => `0 0 0 2px ${t.palette.primary.main}` },
      }}
    >
      {children}
    </Box>
  );
}
